import React, { Component } from "react";
import {Radio, Spin } from "antd";
import { translate } from "$ACTIONS/Translate";
import DailyRewards from "./dailyRewards";
import BonusHistory from "./bonusHistory";
import {
    getQueryVariable,
} from "$ACTIONS/helper"
import { getStaticPropsFromStrapiSEOSetting } from '$DATA/seo';
export async function getStaticProps() {
    return await getStaticPropsFromStrapiSEOSetting('/daily-gift'); //參數帶本頁的路徑
}
export default class Dailydeals extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            radioActiveKey: "1",
        };
    }
    componentWillUnmount() {
        this.setState = () => false;
    }
    onChangeRadio(e) {
        if(e.target.value == "2" && !this.props.isLogin){
            return global.goUserSign(getQueryVariable("isAgent") === "1" ? "2" : "1");
        }
        this.setState({ radioActiveKey: e.target.value });
        e.target.value == "1" ? Pushgtagdata("Promotion_DailyDeal","Switch to Daily Deal","Promotion_DailyDeal_C_DailyDeal")
        : Pushgtagdata("Promotion_DailyDeal","Switch to Daily Deal Record","Promotion_DailyDeal_C_DailyDealRecord");
    }

    setLoading =(v)=> {
        this.setState({loading: v})
    }

    render() {
        const {
            loading,
            radioActiveKey
        } = this.state;
        return (
            <Spin
                size="large"
                tip={translate("加载中")}
                spinning={loading}
            >
                <div className="dailydeals-wrap">
                    {radioActiveKey === "2"  && <div className="yellowNote">Lưu ý: Thưởng Mỗi Ngày đã được nâng cấp thành nhiệm vụ hàng ngày tại Sảnh Tiền Thưởng. Lịch sử cũ chỉ có thể truy cập cho dến 25/11.</div>}
                    <div className="daily-content">
                         <Radio.Group
                            className="my-promotion-filter-box"
                            defaultValue="1"
                            value={radioActiveKey}
                            onChange={(e)=>this.onChangeRadio(e)}
                        >
                            <Radio.Button value="1">{translate("每日好礼")}</Radio.Button>
                            <Radio.Button value="2">{translate("奖励历史记录")}</Radio.Button>
                        </Radio.Group>
                        {radioActiveKey === "1" ? 
                            <DailyRewards setLoading={this.setLoading}/>
                            : <BonusHistory setLoading={this.setLoading} radioActiveKey={radioActiveKey} topTabIndex={this.props.topTabIndex}/>
                        }
                    </div>
                </div>
            </Spin>
        );
    }
}
